
export function decodeHTML(text: string) {
  const element = document.createElement('div');
  element.textContent = text;
  return element.innerHTML;
}